<agpr-take-over-panel
    [id]="id"
    header="CustomPrompt.prompt.dialog.title"
    [responsiveWidth]="true"
    [minPanelWidth]="980"
    [maxPanelWidth]="980"
    [showFooter]="true"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="onVisibleChange($event)"
    [fullHeight]="false"
    styleClass="agpr-manage-prompt"
>
    <ng-template #takeOverFooterRight>
        <agpr-button
            label="done"
            [id]="id + '_footer_done'"
            [style]="buttonTypes.primary"
            (click)="onDone()"
        ></agpr-button>
    </ng-template>

    <div class="agpr-manage-promptContainer">
        <section class="agpr-manage-promptSection agpr-manage-promptSectionList">
            <div class="agpr-manage-promptSection-header">
                <div class="agpr-manage-promptSection-title">{{'CustomPrompt.prompt.list.section.title' | localize}}</div>
                <div class="agpr-manage-promptSectionList-search">
                    <agpr-dropdown
                        [id]="id + '_promptTypes_dropdown'"
                        [options]="dropdownPromptTypes"
                        optionLabel="label"
                        optionStyleClass="agpr-manage-promptSectionList-dropdownOption"
                        [(ngModel)]="selectedPromptType"
                        (ngModelChange)="onChangePromtType()"
                        [bindToValue]="true"
                        [itemTemplate]="itemTemplate"
                        [alignPanelRight]="false"
                    ></agpr-dropdown>
                    <ng-template #itemTemplate let-option let-selected="selected">
                        @if (option) {
                            @if (option?.optionType === dropdownGroupOptionType.GROUP) {
                                <div class="agpr-manage-promptSectionList-dropdownParent">{{ option.label | localize }}</div>
                            } @else {
                                <div class="agpr-manage-promptSectionList-dropdownChild">{{ option.label | localize }}</div>
                            }
                        }
                    </ng-template>
                    <agpr-button
                        [id]="id + '_create'"
                        [style]="buttonTypes.icon"
                        icon="fa-regular fa-duotone fa-square-plus"
                        tooltip="CustomPrompt.prompt.prompt.create"
                        tooltipPosition="top"
                        (click)="onShowCreatePromptPanel()"
                    ></agpr-button>
                </div>
            </div>
            <div class="agpr-manage-promptSection-content" [agprLoading]="isLoading">
                @let prompts = promptsList[selectedPromptType];
                @if (prompts.length > 0) {
                    <agpr-scroll-panel #listScrollPanel>
                        <ul>
                            @for (prompt of prompts; track prompt.id) {
                                <ng-container *ngTemplateOutlet="promptCard; context: { prompt: prompt }"></ng-container>
                            }
                        </ul>
                    </agpr-scroll-panel>
                } @else {
                    <div class="agpr-manage-promptSection-noContent">
                        <agpr-message [severity]="messageSeverity.noContent">
                            {{ 'CustomPrompt.prompt.list.section.noContent' | localize }}
                        </agpr-message>
                    </div>
                }
            </div>
        </section>
        @let editingWithoutContent = (editingMode == contentMode.UPDATE) && !selectedInsightId;
        @if(editingWithoutContent) {
            <section class="agpr-manage-promptSection agpr-manage-promptSectionInput agpr-manage-promptSection--gray"></section>
        } @else {
             <section class="agpr-manage-promptSection agpr-manage-promptSectionInput">
                <div class="agpr-manage-promptSection-header">
                    <div class="agpr-manage-promptSection-title">{{(editingMode == contentMode.UPDATE ? 'CustomPrompt.prompt.prompt.section.update.title' : 'CustomPrompt.prompt.prompt.section.create.title') | localize }}</div>
                </div>
                <div class="agpr-manage-promptSection-content">
                    <agpr-scroll-panel>
                        <agpr-text-input
                            [id]="id + '_name_input'"
                            label="CustomPrompt.prompt.prompt.section.name.input"
                            [required]="true"
                            [(ngModel)]="editingContent.name"
                            ariaLabel="CustomPrompt.prompt.prompt.section.name.input"
                            placeholder="CustomPrompt.prompt.prompt.section.name.input.placeholder"
                            (ngModelChange)="onCheckChange()"
                            [maxLength]="64"
                        >
                        </agpr-text-input>
                        <agpr-textarea-input
                            [id]="id + '_prompt_input'"
                            label="CustomPrompt.prompt.prompt.section.prompt.input"
                            [required]="true"
                            [rows]="6"
                            ariaLabel="CustomPrompt.prompt.prompt.section.prompt.input"
                            placeholder="CustomPrompt.prompt.prompt.section.prompt.input.placeholder"
                            [(ngModel)]="editingContent.prompt"
                            (ngModelChange)="onCheckChange()"
                        ></agpr-textarea-input>
                        <div class="agpr-manage-promptSectionInput-buttonContainer">
                            @let nameCompleted = !!editingContent.name;
                            @let promptCompleted = !!editingContent.prompt;
                            @let hasAllRequiredData = nameCompleted && promptCompleted;

                            @let isEditing = editingMode === contentMode.UPDATE && editingContentUpdated;
                            @let isCreating = editingMode === contentMode.CREATE;

                            @let tooltip = hasAllRequiredData
                                ? ''
                                : (!nameCompleted
                                    ? 'CustomPrompt.prompt.prompt.section.prompt.button.name.required.tooltip'
                                    : 'CustomPrompt.prompt.prompt.section.prompt.button.prompt.required.tooltip');
                            <agpr-button
                                [id]="id + '_save_update'"
                                [style]="buttonTypes.tertiary"
                                [disabled]="!((isEditing || isCreating ) && hasAllRequiredData)"
                                [tooltip]="tooltip"
                                [label]="editingMode === contentMode.UPDATE ? 'CustomPrompt.prompt.prompt.section.prompt.button.update' : 'CustomPrompt.prompt.prompt.section.prompt.button.create'"
                                (click)="onUpdateAndSaveInsight()"
                            ></agpr-button>
                        </div>
                    </agpr-scroll-panel>
                </div>
            </section>
        }

    </div>
</agpr-take-over-panel>

<ng-template #promptCard let-prompt="prompt">
    <li class="agpr-manage-promptSectionList-card agpr-contextMenu-parent"
        role="button"
        tabindex="0"
        [id]="id + '_select_item_'+ prompt.id"
        [ngClass]="{'active' : selectedInsightId === prompt.id }"
        (click)="onSelectInsight(prompt.id)"
        (keydown.enter)="onSelectInsight(prompt.id)" >
        <div class="title">{{prompt.name}}</div>
        <span
            role="img"
            class="fa-regular fa-circle-info tooltip"
            [initiallyFocusable]="false"
            [agprTooltip]="prompt.tooltip"
            tooltipPosition="top"
        ></span>
        <div class="agpr-contextMenu bottom right">
            <agpr-button
                [id]="id + '_delete_'+ prompt.id"
                [icon]="'fa-regular fa-duotone fa-trash-can'"
                tooltip="CustomPrompt.prompt.prompt.section.prompt.button.delete"
                [style]="buttonTypes.contextMenu"
                tooltipPosition="top"
                (click)="onDeleteInsight($event, prompt.id)"
            ></agpr-button>

        </div>
    </li>
</ng-template>